// 心里咨询
export default [
  {
    path: '/counseling/counselor-manage',
    component: resolve => require(['@/pages/counseling/counselorManage.vue'], resolve),
    name: 'counselorManage',
    meta: {
      title: '咨询师管理'
    }
  },
  {
    path: '/counseling/schedule-manage',
    component: resolve => require(['@/pages/counseling/scheduleManage.vue'], resolve),
    name: 'scheduleManage',
    meta: {
      title: '排期管理'
    }
  },
  {
    path: '/counseling/appointment-manage',
    component: resolve => require(['@/pages/counseling/counselingAppointmentManage.vue'], resolve),
    name: 'counselingAppointmentManage',
    meta: {
      title: '心理咨询预约'
    }
  },
  {
    path: '/counseling/consulting-files',
    component: resolve => require(['@/pages/counseling/consultingFiles.vue'], resolve),
    name: 'consultingFiles',
    meta: {
      title: '咨询档案'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/counseling.js